import React from "react";
import { FlexGrid } from "@nef/core";
import styled from "styled-components";

const StyledAbout = styled(FlexGrid)`
  &#about {
    font-family: sans-serif;
    font-size: "24px";
    font-weight: 300;
    line-height: 1.5;
    color: "#333333";
    text-align: "left";

    ${FlexGrid.Column} {
      font-size: 18px;
      h3 {
        font-weight: 300;
        font-size: 24px;
        margin-bottom: 0;
      }
    }
    .content-right {
      margin-top: 18px;
      h3 {
        margin: 0;
      }
    }
    .link-group {
      ul {
        margin: 0;
        a {
          font-size: 0.9em;
        }
      }
      li {
        width: 350px;
        list-style-type: square;
        /* list-style-type: circle; */
      }
    }
    .asset-class-list {
      column-count: 2;
      column-gap: 90px;
      li {
        width: 400px;
        /* list-style-type: square; */
      }
    }
    .top-row {
      height: 725px;
    }
  }
`;

export default StyledAbout;
